type TableNo = {
  floor?: string;
  zone?: string;
  table?: string;
  version?: string;
};

/**
 * Build TLV string from table data (not Base64-encoded).
 * Gói lại bằng Tag 62 → TLV chuẩn tổ chức nhóm.
 *
 * @param floor - Tầng của bàn (ví dụ "02")
 * @param zone - Khu vực / sảnh (ví dụ "A1", "VIP")
 * @param table - Mã bàn (ví dụ "007")
 * @param version - (Optional) Phiên bản QR
 * @returns Chuỗi TLV chuẩn (VD: "62240102020202B103030070402v1")
 */
export function buildRawTableNoTLV({
  floor,
  zone,
  table,
  version,
}: {
  floor: string;
  zone: string;
  table: string;
  version?: string;
}): string {
  const tlv = (tag: string, value?: string): string => {
    if (!value) return '';
    const len = value.length.toString().padStart(2, '0');
    return `${tag}${len}${value}`;
  };

  const inner = [
    tlv('01', floor),
    tlv('02', zone),
    tlv('03', table),
    tlv('04', version),
  ].join('');

  const byteLen = Math.ceil(inner.length / 2); // ✅ fix lỗi thập phân
  const len = byteLen.toString().padStart(2, '0');

  return `62${len}${inner}`;
}

/**
 * Parse TLV chuỗi đã gói theo Tag 62 → object gồm floor, zone, table, version
 *
 * @param raw - Chuỗi TLV đầu vào (VD: "62240102020202B103030070402v1")
 * @returns Object kết quả gồm { floor, zone, table, version }
 */
export function parseRawTableNoTLV(raw: string): TableNo {
  const tagMap: Record<string, keyof TableNo> = {
    '01': 'floor',
    '02': 'zone',
    '03': 'table',
    '04': 'version',
  };

  const result: TableNo = {};
  let i = 0;

  if (raw.startsWith('62')) {
    i += 2;
    const len = parseInt(raw.slice(i, i + 2));
    i += 2;
    raw = raw.slice(i, i + len * 2); // cắt đúng số ký tự (len byte * 2)
    i = 0;
  }

  while (i < raw.length) {
    const tag = raw.slice(i, i + 2);
    const len = parseInt(raw.slice(i + 2, i + 4));
    const value = raw.slice(i + 4, i + 4 + len);
    const key = tagMap[tag];
    if (key) result[key] = value;
    i += 4 + len;
  }

  return result as TableNo;
}
